import React from 'react';
import { Link } from 'react-router-dom';
import { useHealthScore } from '../../hooks/useHealthScore';
import CircularProgress from '../ui/CircularProgress';

// One quiet row: the ring, what the score is built from, and the one thing
// that would widen it. The six category bars moved off Home — the score's
// parts are a Data concern.

const CATEGORY_LABELS = {
  sleep: 'sleep', exercise: 'exercise', nutrition: 'food',
  biometric: 'biometrics', mental_health: 'mood', therapy: 'therapy',
};

const listWords = (xs) => xs.length <= 1 ? xs.join('') : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`;

const HealthScoreCard = ({ refreshKey }) => {
  const { scoreData, loading } = useHealthScore(refreshKey);
  if (loading) return <div className="h-[134px] rounded-xl border border-line animate-pulse" aria-hidden="true" />;

  const score = scoreData?.overall_score;
  const scored = Object.keys(scoreData?.category_scores || {}).map((k) => CATEGORY_LABELS[k] || k);
  const missing = scoreData?.coverage?.missing || [];

  let title; let sentence;
  if (score == null) {
    title = 'Health score · not yet';
    sentence = 'It starts once your life shows up here. Log a meal or a walk and watch it begin.';
  } else if (scored.length === 1) {
    title = `Health score · ${scored[0]} only, so far`;
    sentence = 'It grows as more of your life shows up here. Log a meal or a walk and watch it move.';
  } else {
    title = `Health score · ${listWords(scored)}`;
    sentence = missing.length
      ? `Add ${missing[0].toLowerCase()} and it widens.`
      : 'Built from everything you track.';
  }

  return (
    <Link
      to="/data"
      className="grid grid-cols-[96px_1fr] items-center gap-5 rounded-xl border border-line p-[18px] transition-colors hover:border-fg-3"
    >
      <CircularProgress score={score} />
      <div className="min-w-0">
        <div className="text-[1.15rem] font-medium">{title}</div>
        <div className="mt-1 text-fg-3">{sentence}</div>
      </div>
    </Link>
  );
};

export default HealthScoreCard;
